export default "__VITE_ASSET__vkvD6Ynu__"